import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalViewChildDiaryEntry from "root/Modals/ViewChildDiaryEntry/ModalViewChildDiaryEntry";

const useModalViewChildDiaryEntry = () =>
{
    const [dialog, setDialog]  = useState ( { openState: false, event: null })  ;

    const onClickActivate = ( event ) =>
    {
        setDialog ({ 
            openState: true, 
            event, 
        });
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, key: null, event: null });
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                <ModalViewChildDiaryEntry 
                    onClose={onCloseModal}
                    event={dialog.event}
                />
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalViewChildDiaryEntry ;
